import { styled } from '@mui/material/styles';
import c from '@/components/Tables/constatnt';
import IconButton from '@mui/material/IconButton';

const invalidCell = {
  boxShadow: 'inset 0 0 0 1px #BC5353',
  boxSizing: 'border-box',
  padding: 1,
  position: 'relative',
};

export const CellRoot = styled('div', {
  label: 'CellRoot',
})(() => ({
  position: 'relative',
  height: c.ROW_HEIGHT - 2,
  lineHeight: 0,
  fontSize: 0,
  border: 0,

  '& *': {
    fontSize: 12,
    lineHeight: 'normal',
  },
  '&.je-cell-has-error': { ...invalidCell },
  '&.je-cell-mandatory': { ...invalidCell },
  '&.je-cell-disabled': {
    userSelect: 'none',
  },
}));

export const CellToggleButton = styled(IconButton, {
  label: 'CellToggleButton',
})(() => ({
  position: 'absolute',
  width: 24,
  height: 22, // 24px - 2px fake cell have top/bottom 1px offset or 2px bottom border
  borderRadius: 2,
  padding: 0,
  top: 0,
  right: 0,
  margin: 'auto',
  cursor: 'pointer',
  zIndex: 9,

  '& .MuiSvgIcon-root': {
    fontSize: 24,
    color: '#000',
  },
}));

export const CellRendererInput = styled('input', {
  label: 'CellRendererInput',
})(() => ({
  position: 'absolute',
  padding: 0,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  border: '0 none',
  color: 'transparent',
  opacity: 0.001,
  cursor: 'default',

  '&::selection': {
    background: 'transparent',
    opacity: 0.001,
  },
}));

export const CellRendererValue = styled('div', {
  label: 'CellRendererValue',
  shouldForwardProp: (propName) => propName !== 'cellType',
})(({ theme }) => ({
  height: c.ROW_HEIGHT - 2,
  border: 0,
  width: '100%',
  position: 'absolute',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: `${c.ROW_HEIGHT - 2}px`,
  paddingRight: 10,
  paddingLeft: 10,
  paddingTop: 0,
  paddingBottom: 0,
  unicodeBidi: 'plaintext',

  '&:focus': {
    zIndex: 8,
  },

  '&.je-cell-fake-value': {
    pointerEvents: 'none',
    position: 'absolute',
    left: 1,
    top: 1,
    right: 1,
    bottom: 1,
    width: 'auto',
    height: 'auto',
    textAlign: 'left',
  },

  // CELL STATE STYLES
  '&.je-cell-init-value': { color: '#A8B3BDFF' },
  '&.je-cell-readonly': { color: theme.palette.grey[700] },
  '&.je-cell-disabled': { userSelect: 'none' },
  '&.je-cell-drag-available': { outline: `2px solid ${theme.palette.primary.main} !important`, zIndex: 10 },

  // CELL TYPE STYLES
  '&.je-cell-type-float': {
    textAlign: theme.direction === 'rtl' ? 'inherit' : 'right',
  },
  '&.je-cell-type-string': {},
  '&.je-cell-type-string_auto_generated': {},
  '&.je-cell-type-paginated_list, &.je-cell-type-paginated_multiselect_list, &.je-cell-type-index_list': {
    paddingRight: 28,
    paddingLeft: 8,
    paddingTop: 0,
    paddingBottom: 0,
  },
}));
